/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WorkCommentCountParser = /* #__PURE__ */ parsers.object([
    ['workId', codecNumber, 'work_id'],
    ['replyCount', codecNumber, 'reply_count'],
]);
export class WorkCommentCount extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WorkCommentCountParser.decode(input).map(res => new WorkCommentCount(res));
    }
    static unsafeDecode(input) {
        return WorkCommentCount.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WorkCommentCountParser.encode(data);
    }
    static schema() {
        return WorkCommentCountParser.schema();
    }
}
